import axios from 'axios'

import interceptorsInit from './interceptors/init'

// Russia-direct hosts bypass Cloudflare: when the admin is opened on the
// `admin-ru` hostname, talk to the matching `core-ru` API host instead.
const isRuHost = typeof window !== 'undefined' &&
  window.location.hostname.startsWith('admin-ru.')

const baseURL = (isRuHost && process.env.VUE_APP_API_BASE_URL_RU) ||
  process.env.VUE_APP_API_BASE_URL

const apiClient = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'Accept': 'application/json'
  }
})

interceptorsInit(apiClient, ['errors', 'progress', 'lang'])

export default apiClient
